"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var React = require("react");
var actionListToolbar_1 = require("./actionListToolbar");
var App_1 = require("../../App");
var contexts_1 = require("../../interfaces/contexts");
var urls_1 = require("../../urls");
var actionTable_1 = require("./actionTable");
var ActionList = (function (_super) {
    __extends(ActionList, _super);
    function ActionList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickExportToExcel = function (event) {
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                var url = (0, urls_1.resolve)(urls_1.Urls.action_excel, context.project) + window.location.search;
                spinnerStart();
                poll_for_result(url, {}, function () {
                    $('div.load_indicator span#finished').html("0");
                    $('div.load_indicator span#max').html("1");
                }, function (data) {
                }, function () {
                    spinnerStop();
                }, function (errorThrown) {
                    notification(errorThrown, { type: "error" });
                    spinnerStop();
                });
            }
            else {
                throw new Error("Cannot export to Excel in this context");
            }
        };
        _this.clickHandler = function (event, url, popup) {
            if (popup) {
                window.open(url + window.location.search);
            }
            else {
                window.location.href = url;
            }
        };
        return _this;
    }
    ActionList.prototype.render = function () {
        var data = App_1.store.actionlist.data;
        return (React.createElement("div", { className: "ActionList" },
            React.createElement("div", { className: "Div--Background rounded px-3 pb-4 pt-1" },
                React.createElement(actionListToolbar_1.default, { read_only: data.read_only, has_business_model: data.has_business_model, clickHandler: this.clickHandler, clickExportHandler: this.onClickExportToExcel, rows_counter: data.paginator.items }),
                React.createElement(actionTable_1.default, null))));
    };
    ActionList = __decorate([
        mobx_react_1.observer
    ], ActionList);
    return ActionList;
}(React.Component));
exports.default = ActionList;
